<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <ArenaEquipmentForm />
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ArenaEquipmentForm from '@/components/settings/arena/equipment/ArenaEquipmentForm'

export default {
  name: 'ArenaEquipmentAdd',
  components: {
    PageTitle,
    PageRowWrapper,
    ArenaEquipmentForm
  }
}
</script>
